<template>
  <div>
    <div class="sayfahead">
      <h1>{{Sayfa.Adi}}</h1>
      <el-button-group class="YeniBtn" v-if="Kaydet">
        <el-button v-if="$store.getters.Yetki.iptal>1" type="danger" size="small" class="" @click="Islem('iptal')"
                   icon="el-icon-close">Seçilenleri İptal Et
        </el-button>
        <el-button v-if="$store.getters.Yetki.iptal>0" type="success" size="small" class="" @click="Islem('duzenle')"
                   icon="el-icon-check">Seçilenleri Düzenle
        </el-button>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-row :gutter="24">
        <el-col :span="19">
          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>
          <div class="raporbloksabitle" v-if="tableDisplay">
              <el-form @submit.prevent.native="ReferansAl"
                       ref="ReferansForm">
                <el-col :span="4">
                  <el-form-item label="Borçlanma Tarihi">
                    <el-date-picker
                      @change="ReferansAl"
                      v-model="Referans.tTarihi"
                      type="date"
                      format="dd.MM.yyyy">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="Son Ödeme Tarihi">
                    <el-date-picker
                      @change="ReferansAl"
                      v-model="Referans.sTarihi"
                      type="date"
                      format="dd.MM.yyyy">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="Tutar">
                    <el-input @change="ReferansAl" v-model="Referans.Tutar"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="Kategori">
                    <el-cascader
                      collapse-tags
                      @change="ReferansAl"
                      :options="Kategoriler"
                      v-model="Referans.Kategori_id"
                      filterable></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="Açıklama">
                    <el-input @change="ReferansAl" v-model="Referans.Aciklama"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-button class="mt-3 btn-block" @click="ReferansAl" type="info">Referans Al</el-button>
                </el-col>


              </el-form>

          </div>
          <el-table
            v-if="tableDisplay"
            ref="multipleTable"
            class="table-xs"
            :data="tableData"
            :height="Height"
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>


            <el-table-column
              label="Borç Bilgi"
              width="150">
              <template slot-scope="scope">


                <p style="margin:0">
                  <b class="d-block text-mavi">{{scope.row.BorcBilgi.Cari}}</b>
                  <small class="text-info">{{scope.row.BorcBilgi.Bina}}</small>
                </p>

              </template>
            </el-table-column>
            <el-table-column
              label="Borçlanma Tarihi"
              width="120">
              <template slot-scope="scope">
                <el-date-picker
                  v-model="scope.row.tTarihi"
                  type="date"
                  format="dd.MM.yyyy">
                </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column
              label="Son Ödeme Tarihi"
              width="120">
              <template slot-scope="scope">
                <el-date-picker
                  v-model="scope.row.sTarihi"
                  type="date"
                  format="dd.MM.yyyy">
                </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column
              label="Tutar"
              idth="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.Tutar"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="Kategori"
              width="150">
              <template slot-scope="scope">

                <el-cascader
                  collapse-tags
                  :options="Kategoriler"
                  v-model="scope.row.Kategori_id"
                  filterable
                ></el-cascader>

              </template>
            </el-table-column>
            <el-table-column
              label="Evrak No"
              width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.eNo"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="Açıklama">
              <template slot-scope="scope">
                <el-input v-model="scope.row.Aciklama"></el-input>
              </template>
            </el-table-column>

          </el-table>
        </el-col>
        <el-col :span="5">
          <el-collapse class="Filtre" v-model="FiltreCollapse">
            <el-collapse-item :title="Sayfa.FiltreAdi" name="1">

              <el-form :rules="FormHata" :model="Form"
                       @submit.prevent.native="Getir"
                       ref="FiltreForm">

                <el-form-item label="Site / Bina" prop="Bina_id">
                  <el-select v-model="Form.Bina_id" filterable>
                    <el-option-group
                      label="Site Listesi">
                      <el-option
                        v-for="item in Siteler"
                        :key="item.id"
                        :label="item.Adi"
                        :value="item.id">
                      </el-option>
                    </el-option-group>
                    <el-option-group
                      label="Bina Listesi">
                      <el-option
                        v-for="item in Binalar"
                        :key="item.id"
                        :label="item.Adi"
                        :value="item.id">
                      </el-option>
                    </el-option-group>
                  </el-select>
                </el-form-item>
                <el-form-item label="Firma" prop="Cari_id">
                  <el-select v-model="Form.Cari_id" filterable>
                    <el-option
                      v-for="item in Cariler"
                      :key="item.id"
                      :label="item.Unvan"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="Borçlanma Tarihi Aralığı" prop="Tarih">
                  <el-date-picker
                    v-model="Form.Tarih"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="Başlangıç Tarihi"
                    end-placeholder="Bitiş Tarihi"
                    format="dd.MM.yyyy"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="Kategori" prop="Kategori_id">
                  <el-cascader
                    collapse-tags
                    :options="Kategoriler"
                    v-model="Form.Kategori_id"
                    clearable
                    filterable></el-cascader>
                </el-form-item>

                <el-button type="primary" class="btn-block" size="medium" @click="Getir()"
                           icon="el-icon-check">Giderleri Getir
                </el-button>
              </el-form>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>

  import Yukleniyor from "../../components/Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    data() {
      return {
        lo: false,
        FiltreCollapse: '1',
        Yetki: false,
        Height: window.innerHeight - 180,
        Kaydet: false,
        Sayfa: {
          Adi: 'Gider İşlem',
          ButtonAdi: 'Uygula',
          FiltreAdi: 'Filtreleme',
        },
        Referans: {
          tTarihi: null,
          sTarihi: null,
          zOran: null,
          zSirket: false,
          oOdeme: false,
          Kategori_id: null,
          Aciklama: null
        },
        Form: {
          Bina_id: null,
          Tarih: [],
          Kategori_id: null,
          Daire_id: null,
          Aciklama: null,
          Meskenler: [],
          Tur: null,
          secilenData: []
        },
        FormHata: {
          Bina_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Cari_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
        Kategoriler: [],
        Cariler: [],
        Binalar: [],
        Siteler: [],
        tableData: [],
        tableDisplay: false,

      }
    },
    methods: {
      ReferansAl() {
        if (this.tableData) {
          this.tableData.forEach(row => {
            if (this.Referans.tTarihi) row.tTarihi = this.Referans.tTarihi;
            if (this.Referans.sTarihi) row.sTarihi = this.Referans.sTarihi;
            if (this.Referans.Tutar) row.Tutar = this.Referans.Tutar;
            if (this.Referans.Kategori_id) row.Kategori_id = this.Referans.Kategori_id;
            if (this.Referans.Aciklama) row.Aciklama = this.Referans.Aciklama;
            row.zSirket = this.Referans.zSirket;
            row.oOdeme = this.Referans.oOdeme;
          });
        }
      },
      Islem(tur) {
        this.lo = true;
        this.$store.dispatch("Put", {...this.Form, path: 'iptal/gider/' + tur})
          .then(response => {
            if (response.Durum == "OK") {
              this.lo = false;
              this.$message.success(response.Mesaj);
              this.hata = response.Hata;
              this.Getir();
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          })

      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
        this.Kaydet = true
      },
      handleSelectionChange(val) {
        this.Form.secilenData = val;
        this.Kaydet = true
      },
      Getir() {
        this.$refs['FiltreForm'].validate((valid) => {
          if (valid) {
            this.lo = true;
            this.$store.dispatch("Post", {...this.Form, path: 'iptal/gider/'})
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.tableData = response.Data;
                  this.tableDisplay = true;
                } else {
                  this.$message.error(response.Mesaj);
                  this.tableDisplay = false;
                }
              })


          }
        })
      },

      SayfaYukle() {
        this.tableData = [];
        this.tableDisplay = false;
        this.lo = true;
        this.$store.dispatch("Get", {path: 'muhasebe/cari'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Cariler = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.$store.dispatch("Get", {path: 'muhasebe/kategori'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Kategoriler = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.$store.dispatch("Get", {path: 'yonetim/bina'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Binalar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.$store.dispatch("Get", {path: 'yonetim/site'})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.Siteler = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        if (this.$route.path == '/iptal/gelir') {
          this.Sayfa.Adi = 'Gelir İşlem';
          this.Form.Tur = 2;
        } else {
          this.Sayfa.Adi = 'Gider İşlem';
          this.Form.Tur = 1
        }
      },
    },
    created() {

      this.Yetki = this.$store.getters.Yetki.iptal == 2 ? true : false;
      var Gun = new Date();
      var AySonu = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
      this.Form.Tarih[0] = Gun;
      this.Form.Tarih[1] = AySonu;
      if (this.$store.getters.BinaBilgi) {
        this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
      }
      this.SayfaYukle();
    },
    computed: {
      Secilen() {
        return this.Form.secilenData
      },
      Tur() {
        return this.$route.path
      }
    },
    watch: {
      Secilen() {
        if (this.Form.secilenData[0]) this.Kaydet = true; else this.Kaydet = false;
      },
      Tur() {
        this.SayfaYukle();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Iptal/gider.vue